import { AppDispatch } from "../../store";
import { getMetadata } from "../metadata/metadata.thunk";
import { Pricing } from "../pricing_list/pricingListSlice";


export function updatePricingTypeFilters(pricings: Pricing[]): any {
	return async function (dispatch: AppDispatch, getState: any) {
		const state = getState();
		let incomingItems: { id: string; name: string; filterKey: string }[] =
			[];
		pricings.forEach((pricing: any) => {
			const pickListIndex = state.filters.lists.findIndex(
				(l: any) => l.id === `pricing_type_/${pricing.tender_id}`
			);
			if (pickListIndex > -1) {
				const index = state.filters.lists[
					pickListIndex
				].items.findIndex(
					(item: any) => item.id === pricing.pricing_type.name
				);
				if (index < 0) {
					incomingItems.push({
						id: pricing.pricing_type.name,
						name: pricing.pricing_type.display_name,
						filterKey: "pricing_type",
					});
				}
			}
		});
		if (incomingItems.length > 0 && pricings.length > 0) {
			dispatch(
				getMetadata("Pricings", pricings[0].tender_id, incomingItems)
			);
		}
	};
}

export function updateDeliveryPeriodsFilters(pricings: Pricing[]): any {
	return async function (dispatch: AppDispatch, getState: any) {
		const state = getState();
		pricings.forEach((pricing: Pricing) => {
			const pickListIndex = state.filters.lists.findIndex(
				(l: any) => l.id === `delivery-periods_/${pricing.tender_id}`
			);

			if (pickListIndex > -1) {
				const index = state.filters.lists[
					pickListIndex
				].items.findIndex(
					(item: any) => item.id === pricing.delivery_period
				);

				if (index < 0) {
					dispatch(
						getMetadata("Pricings", pricing.tender_id, [
							{
								id: pricing.delivery_period,
								name: pricing.delivery_period,
								filterKey: "delivery-periods",
							},
						])
					);
				}
			}
		});
	};
}

export function updatePartiesFilters(pricings: Pricing[]): any {
	return async function (dispatch: AppDispatch, getState: any) {
		const state = getState();
		pricings.forEach((pricing: Pricing) => {
			const pickListIndex = state.filters.lists.findIndex(
				(l: any) => l.id === `parties_/${pricing.tender_id}`
			);
			if (pickListIndex > -1) {
				pricing.parties?.forEach((pricingParty) => {
					const index = state.filters.lists[
						pickListIndex
					].items.findIndex(
						(item: any) => Number(item.id) === pricingParty.party_id
					);

					if (index < 0) {
						dispatch(
							getMetadata("Pricings", pricing.tender_id, [
								{
									id: pricingParty.party_id.toString(),
									name: pricingParty.party.name,
									filterKey: "parties",
								},
							])
						);
					}
				});
			}
		});
	};
}
